import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  SimpleDataTable as DataTable,
  Loader,
  ButtonOBSOLETED,
  Notification,
  Message
} from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import { Filters, FilterInput } from './Filters';
import { getQueryStringParameters } from '../../common/utils';
import determineFieldType from '../../common/determineFieldType';
import {
  DisplayDate,
  DisplayGuid
} from '../items';

const resultsCount = 15;

class UsersInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  goToPage(number) {
    // TODO consider to move responsability to filter component
    const { history, location } = this.props;
    const filters = Object.assign(
      {},
      getQueryStringParameters(location.search),
      {
        page: number
      });
    const search = Object.keys(filters)
      .filter(key => key && filters[key])
      .map(key => `${key}=${encodeURIComponent(filters[key])}`).join('&');
    history.push(`?${search}`);
  }

  async loadData(key, skipPages) {
    const { props: { api: { users: { searchUsers } } } } = this;
    const field = await determineFieldType(key);

    let result = null;

    this.setState({ isLoading: true });

    try {
      result = await searchUsers({
        key,
        skipPages,
        resultsCount
      });
    }
    catch (e) {
      this.setState({
        errorMessage: new Message('error', 'Unable to load data')
      });

      result = [];
    }

    this.setState({ isLoading: false });

    return result;
  }

  render() {
    const { location } = this.props;
    const { isLoading, errorMessage } = this.state;
    const parameters = getQueryStringParameters(location.search);
    const pageNumber = parameters.page ? parseInt(parameters.page, 10) : 1;
    const { history } = this.props;

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />
            <PageTop
              documentTitle='Users page'
              documentDescription='Users page'
            />

            <h2 className='main-page-header'>Users</h2>

            <Filters
              initFromUrl
              submitUrl
              validateForm={({
                search
              }) => ({ search })}
              render={(formData, update) => (
                <div className='filters-block'>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='search'>
                      Search
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='search'
                      placeholder='Find by id, email, name or phone'
                    />
                  </div>
                  <br />
                  <br />
                  <div className='filters-submit-wrapper'>
                    <ButtonOBSOLETED type='submit' buttonContent='Search' disabled={isLoading} />
                  </div>
                  <hr />
                </div>
              )}
            />
            <br />
            <DataTable
              style={{ marginTop: '100px' }}
              loadingContent={(<Loader hasLoaded={false} />)}
              tableConfig={{
                tableName: '',
                rowClasses: 'hover-listview',
                rowClick: ({ Id }) => {
                  history.push(`/user/${Id}`);
                },
                columns: [
                  {
                    property: 'Id',
                    label: 'Id',
                    render: ({ Id }) => <DisplayGuid>{Id}</DisplayGuid>
                  }, {
                    property: 'Name',
                    label: 'Name'
                  }, {
                    property: 'Email',
                    label: 'Email'
                  }, {
                    property: 'PhoneNumber',
                    label: 'Phone'
                  }, {
                    property: 'Created At (CET)',
                    label: 'Created At (CET)',
                    render: ({ CreatedAtCet }) => <DisplayDate>{CreatedAtCet}</DisplayDate>
                  }
                ]
              }}
              getData={async newPageNumber => {
                const { search } = getQueryStringParameters(location.search);

                return this.loadData(search, newPageNumber || 1);
              }}
              paginationData={{
                renderLocation: 'both',
                rowsPerPage: resultsCount,
                pageNumber,
                goToPageNumber: number => this.goToPage(number)
              }}
              skipTableNoResults
              cellVerticalAlign='top'
              hideTableHead={false}
              languageCode='en'
              labels={{
                tableBody: {
                  noResult: <div style={{ display: 'block', textAlign: 'center' }}>No Results</div>
                }
              }}
              cellContent='cellContent'
            />
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Users = withRouter(withApi(
  connect(({ user }) => ({ isLoggedIn: !!user }), {})(UsersInternal)
));

Users.requiresLogin = true;
Users.propTypes = { isLoggedIn: PropTypes.bool };

export default Users;
